module.exports = {
    bindings: {
        sectionId: '@'
    },
    controller: nonChapterSectionController,
    templateUrl: 'us/components/hts-non-chapter-section.html'
};

nonChapterSectionController.$inject = [
    'htsOtherSectionsDataService',
    'pdfViewerModal',
];

function nonChapterSectionController(
    htsOtherSectionsDataService,
    pdfViewerModal
) {
    var vm = {
        $onInit: attached,
        openModal: openModal
    };
    return vm;

    function attached() {
        vm.isLoading = true;
        htsOtherSectionsDataService
            .getNonChapterSection(vm.sectionId)
            .then(function (data) {
                vm.isLoading = false;
                vm.section = data;
        });
    }

    function openModal(fileTitle) {
        htsOtherSectionsDataService
            .getHtsPdfFile(fileTitle)
            .then(function (fileUrl) {
                pdfViewerModal.show(fileUrl, fileTitle);
            }); 
    }
}